import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '500+',
  label: 'Familias protegidas'
}, {
  value: '$2.5M+',
  label: 'En beneficios asegurados'
}, {
  value: '98%',
  label: 'Clientes satisfechos'
}];
export function SocialProof() {
  return <section className="bg-deep-blue py-12 border-t border-white/10" data-id="element-109">
      <div className="max-w-6xl mx-auto px-6" data-id="element-110">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-white/20 text-center" data-id="element-111">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="pt-8 md:pt-0 first:pt-0" data-id="element-112">
              <div className="text-4xl md:text-5xl font-bold text-vitality-green mb-2 tracking-tight" data-id="element-113">
                {stat.value}
              </div>
              <div className="text-gray-300 font-medium tracking-wide uppercase text-sm" data-id="element-114">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}